import {
  getBrandNameAutocompleteOptions,
  getCspNameAutocompleteOptions,
} from '@/apis/services';
import { startOfDay, sub } from 'date-fns';
import { FilterType } from 'portal-commons';

const Today = startOfDay(new Date());
const DateRangePresets = [
  {
    label: 'Today',
    start: Today,
    end: Today,
  },
  {
    label: 'Last 7 Days',
    start: sub(Today, { days: 7 }),
    end: Today,
  },
  {
    label: 'Last 1 Month',
    start: sub(Today, { months: 1 }),
    end: Today,
  },
  {
    label: 'Last 6 Months',
    start: sub(Today, { months: 6 }),
    end: Today,
  },
];

export const FilterConfigs = {
  campaignUid: {
    type: FilterType.Text,
    label: 'Campaign ID',
    placeholder: 'Type Campaign ID',
    width: 160,
  },
  brandUid: {
    type: FilterType.Text,
    label: 'Brand ID',
    placeholder: 'Type Brand ID',
    width: 124,
  },
  brandName: {
    type: FilterType.Text,
    label: 'Brand DBA Name',
    placeholder: 'Type Brand DBA Name',
    width: 270,
    suggestions: [],
  },
  primaryDcaUid: {
    type: FilterType.Dropdown,
    options: [],
    label: 'Primary DCA Name',
    multiple: true,
    width: 320,
  },
  usecase: {
    type: FilterType.Dropdown,
    options: [],
    label: 'Usecase',
    width: 200,
  },
  sharedOnDate: {
    type: FilterType.DateRange,
    label: 'Shared On',
    placeholder: 'Select Date Range',
    delayUpdate: false,
    dateRangePresets: DateRangePresets,
  },
  declineDate: {
    type: FilterType.DateRange,
    label: 'Declined On',
    placeholder: 'Select Date Range',
    delayUpdate: false,
    dateRangePresets: DateRangePresets,
  },
  rejectionCategory: {
    type: FilterType.Dropdown,
    label: 'Rejection Category',
    options: [],
    multiple: true,
    width: 260,
  },
  status: {
    type: FilterType.Dropdown,
    label: 'TCR Status',
    options: [
      { label: 'Active', value: 'ACTIVE' },
      { label: 'Deactivated', value: 'EXPIRED' },
    ],
    width: 138,
  },
  provisional: {
    type: FilterType.Dropdown,
    label: 'CNP Migration',
    placeholder: 'Select CNP Migration',
    options: [
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' },
    ],
    width: 138,
  },
};

export const FilterLoaders = {
  suggestion: {
    brandName: {
      minLength: 2,
      load: (value: string) => getBrandNameAutocompleteOptions(value),
    },
  },
};

export const TableHeaders = [
  { id: 'campaignUid', label: 'Campaign ID', sortable: true },
  { id: 'brandUid', label: 'Brand ID', sortable: true },
  { id: 'brandName', label: 'Brand DBA Name', sortable: false },
  { id: 'primaryDcaName', label: 'Primary DCA', sortable: false },
  { id: 'electedMno', label: 'Elected for MNO', sortable: false },
  { id: 'usecase', label: 'Usecase', sortable: true },
  { id: 'sharedOnDate', label: 'Shared On', sortable: true },
  { id: 'updateOnDate', label: 'Declined On', sortable: true },
  { id: 'description', label: 'Description', sortable: false },
  { id: 'status', label: 'TCR Status', sortable: false },
];
